import { getNullDisplayValue } from "metabase/utils/constants";
import { formatValue } from "metabase/value-formatting";
import type { ColumnSettings, DatasetColumn } from "metabase-types/api";

import type {
  ComputedVisualizationSettings,
  RemappingHydratedDatasetColumn,
} from "../../types";

export const formatValueForTooltip = ({
  value,
  column,
  settings,
  isAlreadyScaled,
}: {
  value?: unknown;
  column?: RemappingHydratedDatasetColumn | DatasetColumn | null;
  settings?: ComputedVisualizationSettings;
  isAlreadyScaled?: boolean;
}) => {
  const options: ColumnSettings = {
    ...(settings && settings.column && column
      ? settings.column(column)
      : { column }),
    type: "tooltip",
    majorWidth: 0,
  };

  if (isAlreadyScaled) {
    options.scale = 1;
  }

  return formatValue(value, options) ?? getNullDisplayValue();
};
